"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ServiceUrlsProvider = void 0;
var _serviceUrlsContext = require("./serviceUrlsContext");
var _useServiceUrlsProvider = require("./useServiceUrlsProvider");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Simple Context for keeping and providing service URLs to components down the tree.
 */
const ServiceUrlsProvider = ({
  serviceUrls,
  children
}) => {
  const contextValue = (0, _useServiceUrlsProvider.useServiceUrlsProvider)({
    serviceUrls
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_serviceUrlsContext.serviceUrlsContext.Provider, {
    value: contextValue,
    children: children
  });
};
exports.ServiceUrlsProvider = ServiceUrlsProvider;
